import { z } from 'zod';

import { opMeta } from '../op-meta.ts';
import { booleanCol } from '../schema/types.ts';
import { defineFold, defineUnary } from './helpers.ts';

// Boolean.

export const and = z
  .object({
    name: z.literal('and'),
    params: z.array(z.unknown()),
  })
  .describe('Logical AND. (and a b c) is true iff every arg is truthy. (and) → true.')
  .register(opMeta, {
    terseGroup: 'logic',
    example: { expr: '(and true true false)', result: 'false' },
    ...defineFold<boolean>((vs) => vs.every((v) => v), Boolean, booleanCol),
  });

export const or = z
  .object({
    name: z.literal('or'),
    params: z.array(z.unknown()),
  })
  .describe('Logical OR. (or a b c) is true iff any arg is truthy. (or) → false.')
  .register(opMeta, {
    terseGroup: 'logic',
    example: { expr: '(or false false true)', result: 'true' },
    ...defineFold<boolean>((vs) => vs.some((v) => v), Boolean, booleanCol),
  });

export const not = z
  .object({
    name: z.literal('not'),
    params: z.tuple([z.unknown()]),
  })
  .describe('Logical NOT. (not x) is true iff x is falsy.')
  .register(opMeta, {
    terseGroup: 'logic',
    example: { expr: '(not false)', result: 'true' },
    ...defineUnary((v) => !v, undefined, booleanCol),
  });
